import { BLATT_TOTAL } from '../../lib/teilnehmerakte'

export type PortalPhase = { kind: 'welcome' } | { kind: 'sheet'; index: number }

export function openedPhase({ resume, anyComplete }: { resume: number | null; anyComplete: boolean }): PortalPhase {
  return anyComplete ? { kind: 'welcome' } : { kind: 'sheet', index: resume ?? BLATT_TOTAL - 1 }
}
